var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstructionalVideosIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 23,
    viewBox: "0 0 18 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3752 0.703125H2.67505C1.47877 0.703125 0.5 1.6819 0.5 2.87817V20.2786C0.5 21.4748 1.47877 22.4536 2.67505 22.4536H15.7253C16.9216 22.4536 17.9004 21.4748 17.9004 20.2786V7.22827L11.3752 0.703125ZM2.67505 20.2786V2.87817H10.2877V8.3158H15.7253V20.2786H2.67505ZM11.3752 13.7534L13.5503 12.6006V17.0812L11.3752 15.9285V17.016C11.3752 17.6141 10.8859 18.1035 10.2877 18.1035H5.93762C5.33948 18.1035 4.8501 17.6141 4.8501 17.016V12.6659C4.8501 12.0678 5.33948 11.5784 5.93762 11.5784H10.2877C10.8859 11.5784 11.3752 12.0678 11.3752 12.6659V13.7534Z",
    fill: "#00BC92"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstructionalVideosIcon);
export default __webpack_public_path__ + "static/media/instructionalVideosIcon.065f922bfa0688d773f29ccf8231eca2.svg";
export { ForwardRef as ReactComponent };